import React from "react";
import { Select, Form } from 'antd';
import { isValid,isValidArray, isValidNumber } from "../../../utils/utilities";
import   './schedule-select.style.scss';

const { Option } = Select;

const ALL_VALUE = '__ALL__';

const renderSchedules=(schedules,key,isTripSheetPermissionCheck)=>{
    let scheduleArray=[];
    if(isValidArray(schedules)&&schedules.length>0){
        schedules.forEach(element => {
            if(isValidArray(element)){
                let isAllowed = (isTripSheetPermissionCheck && (!isValidNumber(element.trip_sheet_permission)||element.trip_sheet_permission === 1)) || !isTripSheetPermissionCheck ? true : false; 
                if(isAllowed){
                    scheduleArray.push(<Option key={element.id} value={element[key]} schedule={element}>{element.description}</Option>)
                }
            }else{
                scheduleArray.push(<Option key={element} value={element} schedule={element}>{element}</Option>)

            }    
        });
    }
    return scheduleArray;
}

export const ScheduleSelect = ({
    schedules,
    optionKey,
    showLabel = false,
    isManditory = true,
    isFixedWidth = false,
    isTripSheetPermissionCheck = false,
    mode = null,
    fieldName = 'returnId',
    showAllOption = false,
    allLabel = 'All',
}) => {
    const getAllValues = () => {
        const values = [];
        if (isValidArray(schedules) && schedules.length > 0) {
            schedules.forEach((element) => {
                if (isValidArray(element)) {
                    const isAllowed =
                        (isTripSheetPermissionCheck &&
                            (!isValidNumber(element.trip_sheet_permission) || element.trip_sheet_permission === 1)) ||
                        !isTripSheetPermissionCheck
                            ? true
                            : false;
                    if (isAllowed) values.push(element[optionKey]);
                } else {
                    values.push(element);
                }
            });
        }
        return values.filter((v) => v != null);
    };

    return (
        <Form.Item shouldUpdate noStyle>
            {(ctx) => {
                const allValues = getAllValues();
                const currentValue = ctx?.getFieldValue ? ctx.getFieldValue(fieldName) : undefined;
                const isMultiple = mode === 'multiple';
                const isAllSelected =
                    isMultiple &&
                    Array.isArray(currentValue) &&
                    allValues.length > 0 &&
                    currentValue.length === allValues.length;

                return (
                    <Form.Item
                        name={fieldName}
                        label={showLabel ? "Select Schedule" : ""}
                        rules={[{ required: isManditory, message: 'Please input your schedule!' }]}
                    >
                        <Select
                            mode={mode}
                            size="large"
                            showSearch
                            placeholder="Select a schedule"
                            optionFilterProp="childrens"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            bordered={true}
                            className={isFixedWidth ? "defalut-select-style" : "report-schedule-select-style"}
                            maxTagCount={isMultiple ? 1 : undefined}
                            maxTagPlaceholder={() => (isAllSelected ? allLabel : '...')}
                            onSelect={(val) => {
                                if (!isMultiple) return;
                                if (!showAllOption) return;
                                if (val !== ALL_VALUE) return;
                                const next = [...allValues];
                                if (ctx?.setFieldsValue) {
                                    ctx.setFieldsValue({ [fieldName]: next });
                                }
                            }}
                        >
                            {showAllOption && mode === 'multiple' ? (
                                <Option key={ALL_VALUE} value={ALL_VALUE}>
                                    {allLabel}
                                </Option>
                            ) : null}
                            {renderSchedules(schedules, optionKey, isTripSheetPermissionCheck)}
                        </Select>
                    </Form.Item>
                );
            }}
        </Form.Item>
    );
}